import React, { useEffect, useState } from 'react'

import { getUrl } from '@js/common/getUrlByDomain'
import { UA } from '@js/common/UA'

import { Spinner } from '@f-fertighaus/applications/RequestWizard/steps/UserActivation/Spinner/Spinner'
import { UserExistsMessage } from '@f-fertighaus/applications/RequestWizard/steps/UserActivation/UserExistsMessage'

function redirectToUserAccount() {
  window.location.href = `${getUrl('userAccount')()}favoriten/`
}

const PROGRESS = {
  LOADING: 'LOADING',
  USER_REGISTERED: 'USER_REGISTERED',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS'
}

export const UserActivation = props => {
  const [progress, setProgress] = useState(PROGRESS.LOADING)

  useEffect(() => {
    const handleUATokenUpdate = () => {
      setProgress(PROGRESS.USER_REGISTERED)
      const UAToken = UA.getToken()
      const [house] = props.data.selected_instances.houses
      const houseNid = house.nid
      if (houseNid && UAToken) {
        UA.addFavourite(houseNid).then(redirectToUserAccount)
      }
    }
    window.addEventListener('storage', handleUATokenUpdate)
    return () => window.removeEventListener('storage', handleUATokenUpdate)
  }, [])

  useEffect(() => {
    if (props.userAlreadyExists) {
      setProgress(PROGRESS.USER_ALREADY_EXISTS)
    }
  }, [props.userAlreadyExists])

  const isConversionFunnel = Boolean(props.funnelVariant)

  return {
    [PROGRESS.LOADING]: isConversionFunnel ? (
      <div className='RequestWizard-form-wrapper--HDP_conversion-funnel f-p-b-080'>
        <Spinner />
      </div>
    ) : (
      <Spinner />
    ),
    [PROGRESS.USER_REGISTERED]: isConversionFunnel ? (
      <div className='RequestWizard-form-wrapper--HDP_conversion-funnel f-p-b-080'>
        <Spinner />
      </div>
    ) : (
      <Spinner />
    ),
    [PROGRESS.USER_ALREADY_EXISTS]: isConversionFunnel ? (
      <div className='RequestWizard-form-wrapper--HDP_conversion-funnel f-p-b-080'>
        <UserExistsMessage />
      </div>
    ) : (
      <UserExistsMessage />
    )
  }[progress]
}
